import { gql } from "@apollo/client";

export const VAT_TYPE_ENUM = gql`
  query {
    listThirdPartyAccountingVatTypeChoices {
      label
      value
    }
  }
`;

export const FONT_TYPE_ENUM = gql`
  query {
    fontType: __type(name: "FontTypeEnum") {
      enumValues {
        name
        description
      }
    }
  }
`;
export const DIRECT_DEBIT_STATUS_CHOICES = gql`
  query {
    listDirectDebitStatus {
      label
      value
    }
  }
`;

export const CLIENT_TYPE_ENUM = gql`
  query {
    listClientTypeChoices {
      label
      value
    }
  }
`;
